import { useState } from "react";

interface Props {
  sessionId: string;
  resultDestination: string;
  onClose: () => void;
}

export function FeedbackModal({ sessionId, resultDestination, onClose }: Props) {
  const [text, setText] = useState("");
  const [contact, setContact] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const submit = async () => {
    if (text.trim().length < 8) return;
    setSubmitting(true);
    try {
      await fetch("/api/feedback", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          session_id: sessionId,
          feedback_text: text.trim(),
          contact: contact.trim() || undefined,
          result_destination: resultDestination,
        }),
      });
      setSubmitted(true);
      setTimeout(onClose, 1800);
    } catch {
      // Best-effort; user can retry
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-backdrop active" onClick={onClose}>
      <div className="modal-sheet" onClick={(e) => e.stopPropagation()}>
        <div className="modal-handle" />
        {submitted ? (
          <div style={{ textAlign: "center", padding: "32px 16px 24px" }}>
            <div style={{
              width: 44, height: 44, margin: "0 auto 14px",
              borderRadius: "50%", background: "rgba(98,210,154,0.15)",
              color: "var(--success)", fontSize: 22,
              display: "flex", alignItems: "center", justifyContent: "center",
            }}>✓</div>
            <h3 style={{ fontSize: 20, fontWeight: 600, margin: "0 0 6px" }}>收到了，谢谢 🙏</h3>
            <p style={{ margin: 0, fontSize: 14, color: "var(--text-secondary)" }}>我们看完会想想怎么改。</p>
          </div>
        ) : (
          <>
            <div style={{ fontSize: 20, fontWeight: 600, marginBottom: 6 }}>反馈</div>
            <div style={{ fontSize: 13, color: "var(--text-secondary)", marginBottom: 12 }}>
              觉得推荐不准？想到什么想说的？写两句吧。
            </div>
            <textarea
              className="fb-textarea"
              maxLength={600}
              placeholder="推荐准吗？想看到的目的地？哪里能做得更好？我们都听。"
              value={text}
              onChange={(e) => setText(e.target.value)}
            />
            <div style={{ fontSize: 12, color: "var(--text-secondary)", margin: "14px 0 6px" }}>
              微信号 / 邮箱（选填）
            </div>
            <input
              className="fb-input"
              placeholder="方便我们回复你"
              value={contact}
              onChange={(e) => setContact(e.target.value)}
            />
            <div style={{ fontSize: 11, color: "var(--text-tertiary)", marginTop: 10, lineHeight: 1.5 }}>
              提交即同意我们用以上信息回复你；不会用于其他用途，也不会分享给第三方。
            </div>
            <div style={{ display: "flex", gap: 10, marginTop: 16 }}>
              <button className="btn btn-ghost" style={{ flex: 1 }} onClick={onClose}>算了</button>
              <button
                className="btn btn-primary"
                style={{ flex: 1 }}
                disabled={text.trim().length < 8 || submitting}
                onClick={submit}
              >
                {submitting ? "发送中…" : "发送"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
